import { apiClient } from "./client";

/**
 * Policy Generator API - generates TRONC policy documents from live config.
 */
export const policyGeneratorApi = {
  /**
   * Generate a policy document for the current tenant.
   * @param {string} [ruleId] - Optional rule ID to generate for a specific rule
   */
  generate(ruleId = null) {
    const params = ruleId ? `?ruleId=${ruleId}` : "";
    return apiClient.get(`/policygenerator${params}`);
  },

  /**
   * Generate a policy preview with custom eligibility rules (what-if).
   * @param {object} [eligibilityRules] - Custom eligibility rules
   * @param {string} [ruleId] - Optional rule ID
   */
  preview(eligibilityRules = null, ruleId = null) {
    const params = ruleId ? `?ruleId=${ruleId}` : "";
    return apiClient.post(`/policygenerator/preview${params}`, eligibilityRules);
  },
};

export default policyGeneratorApi;
